(function(win, doc) {
  const { themeSettings, layoutHelpers, attachMaterialRipple, detachMaterialRipple, SideNav } = win
  let [ firstLoad, sidenavInstance ] = [ true, null ]

  doc.addEventListener('turbo:before-render', e => {
    if (!themeSettings || doc.documentElement.hasAttribute('data-turbolinks-preview')) return

    // Remove unwanted merged stylesheets on each render
    const selectors = [
      '.theme-settings-bootstrap-css',
      '.theme-settings-appwork-css',
      '.theme-settings-theme-css',
      '.theme-settings-colors-css'
    ];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach((el, index) => {
        if (index > 0) el.remove();
      });
    });

    // Setup theme settings element
    if (!firstLoad) {
      e.data.newBody.querySelectorAll('.layout-wrapper').forEach(el => {
        el.classList.add('layout-sidenav-link-no-transition');
      });
      themeSettings.updateNavbarBg(e.data.newBody)
      themeSettings.updateSidenavBg(e.data.newBody)
      themeSettings.updateFooterBg(e.data.newBody)
      themeSettings._setup(e.data.newBody)
      setTimeout(() => {
        e.data.newBody.querySelectorAll('.layout-wrapper').forEach(el => {
          el.classList.remove('layout-sidenav-link-no-transition');
        });
      }, 50);
    }
  })

  doc.addEventListener('turbo:load', () => {
    if (layoutHelpers) {
      layoutHelpers.init()

      // Update layout
      layoutHelpers.update()

      // Auto update layout
      layoutHelpers.setAutoUpdate(true)

      // Hide sidenav on small screens after page load
      if (layoutHelpers.isSmallScreen()) {
        layoutHelpers.setCollapsed(true, true)
      }
    }

    // Single Consolidated Search Toggle & Click-Outside Delegated Handler
    doc.addEventListener('click', function(event) {
      const target = event.target;
      
      // 1. Check if we clicked the search toggle button (or any of its children)
      const toggleBtn = target.closest('[data-target="#searchContainer"]');
      if (toggleBtn) {
        event.preventDefault();
        console.log('[Search Toggle] Click detected on toggle button!');
        const searchContainer = doc.getElementById('searchContainer');
        if (searchContainer) {
          console.log('[Search Toggle] Found search container in DOM. Classes before:', searchContainer.className);
          const isShown = searchContainer.classList.toggle('show');
          console.log('[Search Toggle] Classes after toggle:', searchContainer.className, 'isShown:', isShown);
          if (isShown) {
            const queryEl = doc.getElementById('query');
            if (queryEl) queryEl.focus();
          }
        } else {
          console.error('[Search Toggle] ERROR: Search container NOT found in DOM!');
        }
        return; // Exit immediately to prevent executing click-outside logic
      }

      // 2. Click-Outside: Close the search container if clicked outside of its form
      const searchContainer = doc.querySelector('.search-container.show');
      if (searchContainer && !target.closest('#searchContainer form')) {
        searchContainer.classList.remove('show');
      }
    });

    // Handle legacy bootstrap custom events if jQuery is loaded in active page
    if (win.jQuery) {
      win.jQuery("#searchContainer").on('shown.bs.collapse', function() {
        const queryEl = doc.getElementById('query');
        if (queryEl) {
          queryEl.focus();
        }
      });
    }

    // Attach material ripple
    if (!firstLoad && attachMaterialRipple && doc.documentElement.classList.contains('material-style')) {
      attachMaterialRipple()
    }

    // Initialize sidenav
    document.querySelectorAll('#layout-sidenav').forEach(el => {
      sidenavInstance = new SideNav(el, {
        orientation: el.classList.contains('sidenav-horizontal') ? 'horizontal' : 'vertical'
      });
    });

    // Initialize sidenav togglers using event delegation
    document.body.addEventListener('click', e => {
      const toggle = e.target.closest('.layout-sidenav-toggle');
      if (toggle) {
        e.preventDefault();
        if (layoutHelpers) {
          layoutHelpers.toggleCollapsed();
        }
      }
    });

    // Swap dropdown menus in RTL mode
    if (doc.documentElement.getAttribute('dir') === 'rtl') {
      document.querySelectorAll('#layout-navbar .dropdown-menu').forEach(el => {
        el.classList.toggle('dropdown-menu-right');
      });
    }

    // Responsive Mobile Hamburger Animations
    document.querySelectorAll(".navbar-toggler").forEach(el => {
      el.addEventListener("click", function() {
        console.log('open mobile menu');
        const navMobile = document.getElementById("nav-mobile-container");
        if (navMobile) {
          navMobile.style.transition = 'right 0.35s ease';
          navMobile.style.right = '0';
        }
      });
    });
  
    const closeNavMobile = document.getElementById("close-nav-mobile");
    if (closeNavMobile) {
      closeNavMobile.addEventListener("click", function() {
        const navMobile = document.getElementById("nav-mobile-container");
        if (navMobile) {
          navMobile.style.transition = 'right 0.35s ease';
          navMobile.style.right = "-300px";
        }
      });
    }
  });

  // Password Definitions Multi-step Animations
  document.addEventListener('click', e => {
    const goToCard = e.target.closest('#go-to-card-data');
    if (goToCard) {
      const pwdEl = document.getElementById("password");
      const confirmEl = document.getElementById("password_confirmation");
      const pwdField = pwdEl ? pwdEl.value : "";
      const confirmPwdField = confirmEl ? confirmEl.value : "";
      
      const alertMsg = document.getElementById("alert-field-msg");

      if (pwdField === "" || confirmPwdField === "") {
        if (alertMsg) {
          alertMsg.style.display = 'block';
          alertMsg.textContent = "Preencha todos os campos.";
        }
      } else {
        if (alertMsg) {
          alertMsg.style.display = 'none';
        }
        const ccFields = document.getElementById("creditcard-fields");
        if (ccFields) {
          ccFields.style.display = 'block';
          ccFields.style.position = 'absolute';
          ccFields.style.top = '0';
          ccFields.style.backgroundColor = '#000';
        }
      }
    }

    const goToPwd = e.target.closest('#go-to-pwd-data');
    if (goToPwd) {
      const ccFields = document.getElementById("creditcard-fields");
      if (ccFields) {
        ccFields.style.display = 'none';
      }
    }

    const starBtn = e.target.closest('#btn-star');
    if (starBtn) {
      document.querySelectorAll('.btn-favorite').forEach(el => {
        el.classList.toggle('favorited-video');
      });
    }

    const likeBtn = e.target.closest('#btn-like');
    if (likeBtn) {
      document.querySelectorAll('.btn-like').forEach(el => {
        el.classList.toggle('favorited-video');
      });
    }

    const showCommentBtn = e.target.closest('#btn-add-comment');
    if (showCommentBtn) {
      document.querySelectorAll('.add-comment').forEach(el => {
        el.style.display = 'block';
      });
    }
  });
  
  doc.addEventListener('turbo:visit', () => {
    firstLoad = false

    // Clean up layoutHelpers
    if (layoutHelpers) {
      layoutHelpers.destroy()
    }

    // Clean up material ripple
    if (detachMaterialRipple) {
      detachMaterialRipple()
    }

    // Destroy sidenav
    if (sidenavInstance) {
      sidenavInstance.destroy()
    }
  })
})(window, document)
